function optionsValidator(options) {
  if (options == null) {
    return true;
  }

  // If the options prop is an Array
  if (options.constructor === Array) {
    options.forEach(option => {
      // If the option is an Object, check for "label" and "value" key/value pairs
      if (typeof option === "object") {
        if (!option.label) {
          throw `Option needs a "label" key/value pair. Given "${option}".`;
        }

        if (!option.value) {
          throw `Option needs a "value" key/value pair. Given "${option}".`;
        }
      }
      // Else if the option isn't a String or Number, indicate we can only have Objects,
      // Strings, or Numbers as options
      else if (typeof option !== "string" && typeof option !== "number") {
        throw `Option needs to be either an Object, String, or Number. Given "${typeof option}".`;
      }
    });
  }
  // Else if the options prop is an Object
  else if (options.constructor === Object) {
    // Check that "optionLabel" and "optionValue" props are defined
    if (!("optionLabel" in options)) {
      throw `Options object needs to define the "optionLabel".`;
    }
    if (!("optionValue" in options)) {
      throw `Options object needs to define the "optionValue".`;
    }

    // Throw error if "items" prop is not defined in the object
    if (!("items" in options)) {
      throw `Options object needs to define its "items".`;
    }
    // Else if we have "items"
    else {
      // Throw error if "items" isn't an Array
      if (options.items.constructor !== Array) {
        throw `"items" in options object needs to be an Array.`;
      }
      // Else make sure that "optionLabel" and "optionValue" props are defined
      else {
        options.items.forEach(item => {
          if (!(options.optionLabel in item)) {
            throw `Item in options.items needs a "${options.optionLabel}" key/value pair. Given "${item}"`;
          }
          if (!(options.optionValue in item)) {
            throw `Item in options.items needs a "${options.optionvalue}" key/value pair. Given "${item}"`;
          }
        });
      }
    }
  }
  return true;
}

export { optionsValidator };
